const tglConvert = (tgl) => {
    var date = new Date(tgl);
    // console.log(date)
    var getBulan = date.getMonth() + 1; var bulan = '';
    if (getBulan == '1') {bulan = 'Jan'} 
    else if(getBulan == '2') {bulan = 'Feb'}
    else if(getBulan == '3') {bulan = 'Mar'}
    else if(getBulan == '4') {bulan = 'Apr'}
    else if(getBulan == '5') {bulan = 'Mei'}
    else if(getBulan == '6') {bulan = 'Jun'}
    else if(getBulan == '7') {bulan = 'Jul'}
    else if(getBulan == '8') {bulan = 'Agt'}
    else if(getBulan == '9') {bulan = 'Sep'}
    else if(getBulan == '10') {bulan = 'Okt'}
    else if(getBulan == '11') {bulan = 'Nov'}
    else if(getBulan == '12') {bulan = 'Des'}

    if (tgl == undefined || tgl == null || tgl == '') {
        var tglku = "-";
        var time = "-"
    } else {
        var tglku = date.getDate() + " " + bulan + " " + date.getFullYear();
        var time = date.getHours() +':'+date.getMinutes()+':'+date.getSeconds()
    }


    return {
        tgl : tglku,
        time : time
    };
}

const hariConvert = (tgl) => {
    var date = new Date(tgl);
    var days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu",];

    var namahari = days[date.getDay()];
        // console.log(days[date.getDay()]);
    return {
        tgl : namahari, 
    };

}
const hitungUmur = (umur) => {
    var date = new Date(umur);
    // console.log(date)
    
    var today = new Date();
    // var birthday = new Date(date);
    var year = 0;
    if (today.getMonth() < date.getMonth()) {
        year = 1;
    } else if ((today.getMonth() == date.getMonth()) && today.getDate() < date.getDate()) {
        year = 1;
    }
    var age = today.getFullYear() - date.getFullYear() - year;

    if(age < 0){
        age = 0;
    }  

    return {
        hitungumur : age
    };
}

const check_gelar_depan = (data) => {
    if (data == undefined || data == null || data == '') {
        return ''
    } else {
        return data+'. '
    }
}
const check_gelar_belakang = (data1) => {
    if (data1 == undefined || data1 == null || data1 == '') {
        return ''
    } else {
        return ', '+data1
    }
}

const namaLengkap = (gelardepan, nama, gelarBelakang) =>{
    return check_gelar_depan(gelardepan)+""+nama+""+check_gelar_belakang(gelarBelakang)
}


// =================== PAGINASI =========================

const btn_prev = (page_first) =>{

}


const btn_next = (page_first, page_last) => {

}


const getDateTime = () => {
    var today = new Date();
    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date+' '+time
    return dateTime
}

const indexing = (hal, limit, index) =>{
    var idx = ((hal-1)*limit)+index
    return idx
}


// ======================= TAMBAHAN ===========================

const checkAddEditRemove = (data) =>{
    if (
        (data.add == null || data.add == undefined ) &&
        (data.edit == null || data.edit == undefined ) &&
        (data.remove == null || data.remove == undefined )
        
        ) 
    {
        return false
    } else {
        return true
    }
}


function cariValue(menu, OBJsected, key){

    var obj = {
        view : false,
        add : false,
        edit : false,
        remove : false
    }

    OBJsected.forEach(element => {
        // console.log(element.menu_list)
        if (menu._id == element.menu_list) {
            obj = {
                view : element.view,
                add : element.add,
                edit : element.edit,
                remove : element.remove
            }
        }   
    });

    return obj[key]
    // var keyku = key

    
    
}

const checkUndefined = (data) =>{

    if (data == null || data == undefined|| data == false){
        return false
    } else {
        return data
    }
}



const filterAddEditRemove = (list_menu) =>{
        var array = list_menu

        var data = [];

        array.forEach(menu => {
            if (menu.type == 'single') {
                checkAddEditRemove(menu)

                // if (check) {
                  data.push({
                      menu_list : menu._id,
                      view : menu.view,
                      add : menu.add,
                      edit : menu.edit,
                      remove : menu.remove,
                  })  
                // } 
            }
            menu.submenu.forEach(submenu => {
                if (submenu.type == 'single') {
                    checkAddEditRemove(submenu)
                    // if (check1) {
                        data.push({
                            menu_list : submenu._id,
                            view : submenu.view,
                            add : submenu.add,
                            edit : submenu.edit,
                            remove : submenu.remove,
                        })    
                    // } 
                }

                submenu.submenu.forEach(subsubmenu => {
                    if (subsubmenu.type == 'single') {
                        checkAddEditRemove(subsubmenu)
                        // if (check2) {
                            data.push({
                                menu_list : subsubmenu._id,
                                view : subsubmenu.view,
                                add : subsubmenu.add,
                                edit : subsubmenu.edit,
                                remove : subsubmenu.remove,
                            })  
                        // } 
                    }
                });


            });
        });

        return data
}


const setFalseAddEditRemove = (list_menu, OBJsected) =>{
    var array = list_menu

    var data = [];

    array.forEach(menu => {
        // console.log(OBJsected.view)
        if (menu.type == 'single') {

            console.log(cariValue(menu, OBJsected, 'view'))

            menu.view = checkUndefined(cariValue(menu, OBJsected, 'view'));
            menu.add = checkUndefined(cariValue(menu, OBJsected, 'add'));
            menu.edit = checkUndefined(cariValue(menu, OBJsected, 'edit'));
            menu.remove = checkUndefined(cariValue(menu, OBJsected, 'remove'));
        }
        menu.submenu.forEach(submenu => {
            if (submenu.type == 'single') {
                submenu.view = checkUndefined(cariValue(submenu, OBJsected, 'view'));
                submenu.add = checkUndefined(cariValue(submenu, OBJsected, 'add'));
                submenu.edit = checkUndefined(cariValue(submenu, OBJsected, 'edit'));
                submenu.remove = checkUndefined(cariValue(submenu, OBJsected, 'remove'));
            }

            submenu.submenu.forEach(subsubmenu => {
                if (subsubmenu.type == 'single') {
                    subsubmenu.view = checkUndefined(cariValue(subsubmenu, OBJsected, 'view'));
                    subsubmenu.add = checkUndefined(cariValue(subsubmenu, OBJsected, 'add b'));
                    subsubmenu.edit = checkUndefined(cariValue(subsubmenu, OBJsected, 'edit'));
                    subsubmenu.remove = checkUndefined(cariValue(subsubmenu, OBJsected, 'remove'));
                }
            });

        });
    });

    return data
}



// ======================= TAMBAHAN ===========================




module.exports = {
    tglConvert : tglConvert,
    hitungUmur : hitungUmur,
    check_gelar_depan : check_gelar_depan,
    check_gelar_belakang : check_gelar_belakang,
    namaLengkap : namaLengkap,
    btn_prev : btn_prev,
    btn_next : btn_next,
    NOW : getDateTime,
    indexing : indexing,
    hariConvert:hariConvert,
    checkAddEditRemove : checkAddEditRemove,
    filterAddEditRemove : filterAddEditRemove,
    setFalseAddEditRemove : setFalseAddEditRemove
}